







































































































import Vue from "vue";

import UserDialog from "@/components/users/UserDialog.vue";
import * as R from "ramda";

import USERS from "@/graphql/users/Users.gql";
import ADMIN_PROJECTS from "@/graphql/projects/AdminProjects.gql";
import USER_DELETE from "@/graphql/users/UserDelete.gql";

import { Users_users_edges_node } from "@/api-types";

export default Vue.extend({
  components: { UserDialog },
  name: "Users",
  apollo: {
    users: {
      query: USERS
    }
  },
  data: () => ({
    removeUser: "",
    editUser: "",
    headers: [
      { text: "Vorname", value: "node.forename" },
      { text: "Nachname", value: "node.surename" },
      { text: "E-Mail-Adresse", value: "node.email" },
      { text: "Benutzername", value: "node.username" },
      { text: "Benutzerrolle", value: "node.roles" },
      { text: "Projekt-Freigaben", value: "node.projects" },
      { text: "Anmerkungen", value: "node.info" },
      { text: "Aktionen", value: "id", sortable: false }
    ],
    roles: {
      ROLE_ADMIN: "Administrator",
      ROLE_PROJECTMANAGER: "Projektleiter",
      ROLE_USER: "Benutzer"
    }
  }),
  methods: {
    deleteUser() {
      this.$apollo
        .mutate({
          mutation: USER_DELETE,
          variables: { id: this.removeUser }
        })
        .then(() => {
          this.removeUser = "";
          this.$apollo.queries.users.refetch();
        });
    },
    projects(user: Users_users_edges_node): string {
      const toolNames = [
        "damageTables",
        "hdrViewers",
        "bimViewers",
        "viewer3ds"
      ];
      let projectList = [] as string[];

      R.forEach((toolName: string) => {
        R.forEach((tool: any) => {
          projectList.push(tool.node.project.name);
        }, (user as any)[toolName].edges);
      }, toolNames);

      return R.join(", ", R.uniq(projectList));
    }
  },
  mounted() {
    document.title = "Hydromapper - Benutzerverwaltung";
    this.$store.commit("setToolbarTitle", "Administration: Benutzerverwaltung");
  }
});
